import styled, { keyframes } from 'styled-components';
import LazyLoadOriginal from '../LazyLoad/LazyLoad';

/** Animation was temporarily removed from Container as performance improvement 
 * Further investigation is needed before adding the animation back. 
*/
export const pulseAnimation = keyframes`
  0%, 100% {
    background-color: var(--hover);
  }
  45% {
    background-color: var(--border);
  }
`;

export const LazyLoad = styled(LazyLoadOriginal)`
  position: absolute;
  inset: 0;
`;

export const Image = styled.img`
  position: absolute;
  width: 100%;
  opacity: ${({ hasLoaded }) => (hasLoaded ? 1 : 0)};
`;

export const Container = styled.div`
  height: 0;
  padding-bottom: ${({ aspectRatio = 1 }) => aspectRatio * 100}%;
  overflow: hidden;
  position: relative;
  ${({ hasLoaded }) => !hasLoaded && 'background-color: var(--product-image-background);'}

  & > ${Image} {
    transition: opacity 100ms ease-in;
    top: 0;
  }
`;
